import { FETCHING_DATA_SUCCESS, FETCHING_DATA_FAILED } from "../actions/types";

const initialState = {
  indexes: [],
  error: "",
  isFetching: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCHING_DATA_SUCCESS:
      return {
        ...state,
        isFetching: true,
        indexes: action.payload,
      };
    default:
      return state;
  }
  switch (action.type) {
    case FETCHING_DATA_FAILED:
      return {
        ...state,
        isFetching: true,
        indexes: action.payload,
      };
    default:
      return state;
  }
}
